import React from "react";

export const CarbonDioxide = () => (
  <svg viewBox="0 0 512 512" width="512px" height="512px">
    <path
      d="M460.46,227.51c1.99-7.34,3.07-15.05,3.07-23.01c0-48.52-39.34-87.86-87.86-87.86
	c-1.51,0-3.01,0.04-4.5,0.11c-15.96-22.08-41.91-36.47-71.24-36.47c-29.01,0-54.73,14.07-70.73,35.75
	c-15.28-12.85-34.99-20.6-56.51-20.6c-45.48,0-82.88,34.55-87.4,78.83C37.96,175.63,0,214.4,0,262.06
	c0,48.52,39.34,87.86,87.86,87.86c0.86,0,1.72-0.04,2.58-0.07c9.47,38.31,44.05,66.72,85.28,66.72c20.66,0,39.64-7.15,54.64-19.08
	c16.07,20.81,41.25,34.23,69.57,34.23c34.57,0,64.45-19.97,78.8-48.99c13.25,8.02,28.79,12.64,45.42,12.64
	c48.52,0,87.86-39.34,87.86-87.86C512,271.94,490.85,241.33,460.46,227.51z"
    />
    <path
      style={{ fill: "#fff" }}
      d="M174.83,307.47c-7.46-4.01-13.33-9.57-17.6-16.69s-6.4-15.16-6.4-24.13c0-8.97,2.13-17.02,6.4-24.13
	c4.27-7.12,10.13-12.68,17.6-16.69c7.46-4.01,15.85-6.02,25.17-6.02c7.85,0,14.94,1.38,21.28,4.14c6.34,2.76,11.66,6.73,15.98,11.9
	l-13.46,12.42c-6.13-7.07-13.72-10.61-22.77-10.61c-5.61,0-10.61,1.23-15.01,3.69c-4.4,2.46-7.83,5.89-10.28,10.28
	c-2.46,4.4-3.69,9.4-3.69,15.01c0,5.61,1.23,10.61,3.69,15.01c2.46,4.4,5.89,7.83,10.28,10.29c4.4,2.46,9.4,3.69,15.01,3.69
	c9.06,0,16.64-3.58,22.77-10.74l13.46,12.42c-4.31,5.26-9.66,9.27-16.04,12.03c-6.38,2.76-13.5,4.14-21.35,4.14
	C190.63,313.49,182.28,311.48,174.83,307.47z"
    />
    <path
      style={{ fill: "#fff" }}
      d="M267.85,307.41c-7.55-4.05-13.46-9.64-17.73-16.75s-6.4-15.12-6.4-24c0-8.88,2.13-16.88,6.4-24
	c4.27-7.12,10.18-12.7,17.73-16.75c7.55-4.06,16.02-6.08,25.42-6.08c9.4,0,17.86,2.03,25.36,6.08c7.5,4.06,13.41,9.64,17.73,16.75
	c4.31,7.11,6.47,15.12,6.47,24c0,8.88-2.16,16.88-6.47,24c-4.32,7.12-10.22,12.7-17.73,16.75c-7.5,4.06-15.96,6.08-25.36,6.08
	C283.87,313.49,275.39,311.46,267.85,307.41z M307.76,291.95c4.31-2.46,7.7-5.89,10.16-10.29c2.46-4.4,3.69-9.4,3.69-15.01
	c0-5.61-1.23-10.61-3.69-15.01c-2.46-4.4-5.85-7.83-10.16-10.28c-4.31-2.46-9.14-3.69-14.49-3.69c-5.35,0-10.18,1.23-14.49,3.69
	c-4.31,2.46-7.7,5.89-10.16,10.28c-2.46,4.4-3.69,9.4-3.69,15.01c0,5.61,1.23,10.61,3.69,15.01c2.46,4.4,5.84,7.83,10.16,10.29
	c4.31,2.46,9.14,3.69,14.49,3.69C298.62,295.63,303.45,294.4,307.76,291.95z"
    />
    <path
      style={{ fill: "#fff" }}
      d="M393.75,217.15v10.3h-41.28v-8.19l21.07-19.9c2.24-2.13,3.75-3.97,4.53-5.5
	c0.78-1.53,1.17-3.06,1.17-4.57c0-2.19-0.74-3.86-2.22-5.03c-1.48-1.17-3.66-1.76-6.52-1.76c-2.39,0-4.55,0.46-6.48,1.37
	c-1.93,0.91-3.54,2.28-4.84,4.1l-9.21-5.93c2.13-3.17,5.07-5.66,8.82-7.45c3.75-1.79,8.04-2.69,12.88-2.69
	c4.06,0,7.61,0.66,10.65,1.99s5.41,3.2,7.1,5.62c1.69,2.42,2.54,5.27,2.54,8.55c0,2.97-0.63,5.75-1.87,8.35
	c-1.25,2.6-3.67,5.57-7.26,8.9l-12.56,11.86H393.75z"
    />
  </svg>
);
